import { render } from "./UploadFile.vue?vue&type=template&id=3819fe6a"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"
script.render = render

export default script